export class SaleOrderDropDownDto {
    saleOrderId: number;
    saleOrderNumber: string;
    poNumber?: string;
    status?: string;

    /**
     * 
     * @param saleOrderId 
     * @param saleOrderNumber 
     */
    constructor(saleOrderId: number,saleOrderNumber: string,poNumber?:string,status?: string,){ 
        this.saleOrderId = saleOrderId
        this.saleOrderNumber = saleOrderNumber
        this.poNumber = poNumber
        this.status = status
         
        }
    }
